import React from 'react'

import { useStyles } from './styles'

export default function TokenInvalid() {
  const classes = useStyles()

  return <div className={classes.content}>Token inválido ou expirado</div>
}
